import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';

import { __t } from 'utils/language';

import './add-zalando-brand-form.scss';

type Props = {
  text: string,
  disabled: boolean,
  onChange: (a: string) => void,
  onSubmit: () => Promise<void>
};

const AddZalandoBrandFormFields = ({
  text,
  disabled,
  onChange,
  onSubmit
}: Props) => (
  <FormField
    label={__t('add_zalando_brand_form.field_lable')}
    labelType="highlighted"
    direction="column"
    fontSize="small"
    showValidationIcon={false}
  >
    <Input
      multiline
      name="newZalandoBrand"
      onChange={e => onChange(e.currentTarget?.value ?? '')}
      value={text}
      placeholder={__t('add_zalando_brand_form.input_placeholder')}
      className="add-zalando-brand-form__input"
    />
    <div className="add-zalando-brand-form__action-button-wrapper">
      <ActionButton
        disabled={disabled}
        color="primary"
        width="maximum"
        onClick={onSubmit}
      >
        {__t('add_zalando_brand_form.button_text')}
      </ActionButton>
    </div>
  </FormField>
);

export default AddZalandoBrandFormFields;
